module.exports = __webpack_public_path__ + "static/media/cq_richieste.d060b003.svg";